import { BoloAdditionalInfo } from '@mark43/cad-api';
import { AdditionalInfoView } from '../types';

export const boloAdditionalInfoToView = (
    view: BoloAdditionalInfo,
    boloNumber: string
): AdditionalInfoView => {
    return {
        id: view.boloLinkId ?? -1,
        text: view.text,
        agencyEventId: view.additionalInfoId ?? -1,
        agencyEventNumber: boloNumber,
        priority: view.additionalInfoPriority,
        type: 'USER',
        isEventNarrative: false,

        createdDateUtc: view.createdDateUtc ?? '',
        authorCallSign: view.authorCallSign ?? '',
        authorUnitId: view.authorUnitId ?? 0,
        authorUserId: view.authorUserId ?? 0,
        userCadId: view.userCadId ?? '',
        userInitials: view.userInitials ?? '',

        parentAgencyEventId: 0,
        parentAgencyEventNumber: '',
    };
};
